<p-dialog
    [(visible)]="visible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closeOnEscape]="!salvataggioInCorso"
    [dismissableMask]="!salvataggioInCorso"
    [style]="{width: '800px', height: '800px'}"
    styleClass="p-fluid comunica-contributo-dialog"
    [showHeader]="false"
    (onHide)="hide()">

    <div class="dialog-container">
        <div class="dialog-header">
            <div class="header-content">
                <i class="pi pi-euro header-icon"></i>
                <h2>Rendiconta Intervento</h2>
                <div class="code-badge" style="background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem;">
                  <span class="code-value" style="font-weight: bold; color: #3a6e75;">{{ intervento?.scheda?.codice }}</span>
                </div>
            </div>
            <button
                pButton
                pRipple
                icon="pi pi-times"
                class="p-button-rounded p-button-text close-btn"
                [disabled]="salvataggioInCorso"
                (click)="hide()">
            </button>
        </div>

        <div class="dialog-content">
            <!-- Step 1: Importo e Tipo Rendicontazione -->
            <div *ngIf="currentStep === 1">
                <!-- <div class="summary-section p-3 mb-4" style="background-color: #f8f9fa; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
                    <div class="grid">
                        <div class="col-12">
                            <div class="summary-card" style="display: flex; justify-content: space-between; align-items: center; padding: 1rem; background: white; border-radius: 6px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
                                <div style="text-align: center; flex: 1;">
                                    <span class="summary-label" style="display: block; color: #6c757d; font-size: 0.875rem; margin-bottom: 0.5rem;">Importo Finanziato</span>
                                    <span class="summary-value" style="display: block; color: #30928b; font-size: 1.25rem; font-weight: 600;">€ {{ intervento?.importoFinanziato | currency:'EUR':'':'1.2-2':'it-IT' }}</span>
                                </div>
                                <div style="text-align: center; flex: 1; border-left: 1px solid #dee2e6; border-right: 1px solid #dee2e6; padding: 0 1rem;">
                                    <span class="summary-label" style="display: block; color: #6c757d; font-size: 0.875rem; margin-bottom: 0.5rem;">Importo da Rendicontare</span>
                                    <span class="summary-value" style="display: block; color: #175220; font-size: 1.25rem; font-weight: 600;">€ {{ importoRendicontato | currency:'EUR':'':'1.2-2':'it-IT' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="field mt-2">
                  <label for="tipoRendicontazione">Tipo Rendicontazione</label>
                  <p-dropdown
                      id="tipoRendicontazione"
                      name="tipoRendicontazione"
                      [options]="tipiRendicontazione"
                      [(ngModel)]="tipoRendicontazione"
                      optionLabel="label"
                      placeholder="Seleziona tipo rendicontazione"
                      styleClass="w-full"
                      [disabled]="disableSelezioneTipoRendicontazione || salvataggioInCorso"
                      (onChange)="onTipoRendicontazioneChange($event)">
                  </p-dropdown>
              </div>
              <div *ngIf="tipoRendicontazione && tipoRendicontazione.value === 'ACCONTO'"
                     class="p-message p-message-warn"
                     style="margin: 1rem 0; padding: 1.25rem; background-color: #fff8e1; border-left: 4px solid #ffc107; border-radius: 4px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
                    <div style="display: flex; align-items: flex-start;">
                        <i class="pi pi-exclamation-triangle" style="color: #ffc107; font-size: 1rem; margin-right: 0.75rem; margin-top: 0.125rem;"></i>
                        <div>
                            <h4 style="margin: 0 0 0.25rem 0; color: #856404; font-size: 0.875rem; font-weight: 600;">Importante</h4>
                            <p style="margin: 0; color: #666; line-height: 1.4; font-size: 0.875rem;">Per l'acconto è necessario indicare il 50% dell'importo effettivo della spesa se l'intervento ha avuto un costo diverso dall'importo finanziato.</p>
                        </div>
                    </div>
                </div>
                <form>
                    <div style="display: flex; gap: 2rem; align-items: center; justify-content: center;">
                        <div style="width: 280px; background: #f8f9fa; padding: 1.5rem; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
                            <label for="importoFinanziato" style="display: block; color: #6c757d; font-size: 0.875rem; margin-bottom: 0.75rem;">Importo Finanziato</label>
                            <p-inputNumber
                                id="importoFinanziato"
                                name="importoFinanziato"
                                [ngModel]="intervento?.importoFinanziato"
                                mode="currency"
                                currency="EUR"
                                locale="it-IT"
                                [disabled]="true"
                                styleClass="w-full"
                                [style]="{'width': '100%'}">
                            </p-inputNumber>
                        </div>
                        <div style="display: flex; align-items: center; color: #6c757d;">
                            <i class="pi pi-arrow-right" style="font-size: 2rem;"></i>
                        </div>
                        <div style="width: 280px; background: #f8f9fa; padding: 1.5rem; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
                            <label for="importoRendicontato" style="display: block; color: #6c757d; font-size: 0.875rem; margin-bottom: 0.75rem;">Importo da Rendicontare</label>
                            <p-inputNumber
                                id="importoRendicontato"
                                name="importoRendicontato"
                                [(ngModel)]="importoRendicontato"
                                mode="currency"
                                currency="EUR"
                                locale="it-IT"
                                [min]="0"
                                [max]="getImportoMassimoConsentito()"
                                styleClass="w-full"
                                [style]="{'width': '100%'}"
                                [disabled]="!tipoRendicontazione || salvataggioInCorso">
                            </p-inputNumber>
                        </div>
                    </div>
                </form>
                <div *ngIf="isSaldoSuperaFinanziato()" class="saldo-warning-card">
                  <div class="saldo-warning-icon-wrap">
                    <i class="pi pi-exclamation-triangle"></i>
                  </div>
                  <div class="saldo-warning-content">
                    <div class="saldo-warning-title">Saldo oltre il finanziato</div>
                    <div class="saldo-warning-text">
                      Stai rendicontando
                      <strong>{{ getEccedenzaSaldo() | currency:'EUR':'':'1.2-2':'it-IT' }}</strong>
                      oltre l'importo finanziato dell'intervento.
                    </div>
                   <!--  <div class="saldo-warning-meta">
                      <span>Gia rendicontato: <strong>{{ getImportoGiaRendicontato() | currency:'EUR':'':'1.2-2':'it-IT' }}</strong></span>
                      <span>Massimo consentito ora: <strong>{{ getImportoMassimoConsentito() | currency:'EUR':'':'1.2-2':'it-IT' }}</strong></span>
                    </div> -->
                  </div>
                </div>
                <div class="form-container form-container-note">
                    <div class="field">
                        <label for="note">Note</label>
                        <textarea
                            id="note"
                            pInputTextarea
                            [(ngModel)]="note"
                            [rows]="3"
                            placeholder="Inserisci eventuali note"
                            class="w-full"
                            style="resize: vertical"
                            [disabled]="!tipoRendicontazione || salvataggioInCorso">
                        </textarea>
                    </div>
                </div>
            </div>

            <!-- Step 2: Caricamento Fatture -->
            <div *ngIf="currentStep === 2">
                <div class="field">
                    <label>Carica {{tipoRendicontazione?.value !== 'ACCONTO' ? 'Fatture' : 'determina o altro documento'}}</label>
                    <p-fileUpload
                        mode="advanced"
                        [multiple]="true"
                        accept="application/pdf"
                        [maxFileSize]="1000000"
                        chooseLabel="Scegli"
                        uploadLabel="Carica"
                        cancelLabel="Annulla"
                        (onUpload)="onFileUpload($event)"
                        (onSelect)="onFileSelect($event)"
                        [auto]="false"
                        [showUploadButton]="false"
                        [showCancelButton]="false"
                        [disabled]="!tipoRendicontazione || salvataggioInCorso">
                    </p-fileUpload>
                </div>

                <div class="field" *ngIf="fatture.length > 0">
                    <label>{{tipoRendicontazione?.value !== 'ACCONTO' ? 'Fatture caricate' : 'Documenti caricati'}}</label>
                    <p-table [value]="fatture" styleClass="p-datatable-sm">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Nome File</th>
                                <th>Importo Complessivo</th>
                                <th>Importo Intervento</th>
                                <th>Elimina</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-fattura>
                            <tr>
                                <td><span style="font-size: 0.9rem;">{{fattura.nome}}</span></td>
                                <td>
                                    <p-inputNumber
                                        [(ngModel)]="fattura.importoComplessivo"
                                        mode="currency"
                                        currency="EUR"
                                        locale="it-IT"
                                        [min]="0"
                                        styleClass="w-full">
                                    </p-inputNumber>
                                </td>
                                <td>
                                    <p-inputNumber
                                        [(ngModel)]="fattura.importoLavoro"
                                        mode="currency"
                                        currency="EUR"
                                        locale="it-IT"
                                        [min]="0"
                                         styleClass="w-full">
                                    </p-inputNumber>
                                </td>
                                <td>
                                    <button
                                        pButton
                                        pRipple
                                        icon="pi pi-trash"
                                        class="p-button-rounded p-button-text"
                                        (click)="rimuoviFattura(fattura)"
                                        [disabled]="fatture.length === 0">
                                    </button>
                                </td>
                            </tr>
                        </ng-template>
                      <!--   <ng-template pTemplate="footer">
                            <tr>
                                <td><strong>Totale</strong></td>
                                <td><strong>{{calcolaTotaleComplessivo() | currency:'EUR'}}</strong></td>
                                <td><strong>{{calcolaTotaleFatture() | currency:'EUR'}}</strong></td>
                                <td></td>
                            </tr>
                        </ng-template> -->
                    </p-table>
                </div>

                <div class="field" *ngIf="fatture.length > 0">
                    <div class="importo-info">
                        <div class="importo-item">
                            <label>Importo da Rendicontare:</label>
                            <span class="importo-value">{{importoRendicontato | currency:'EUR'}}</span>
                        </div>
                        <div class="importo-item">
                            <label>Totale {{tipoRendicontazione?.value !== 'ACCONTO' ? 'Fatture' : 'Documenti'}} caricate:</label>
                            <span class="importo-value" [ngClass]="{'text-danger': calcolaTotaleFatture() !== importoRendicontato}">
                                {{calcolaTotaleFatture() | currency:'EUR'}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="dialog-footer">
            <button
                pButton
                pRipple
                label="Annulla"
                icon="pi pi-times"
                class="p-button-outlined p-button-secondary"
                [disabled]="salvataggioInCorso"
                (click)="hide()">
            </button>
            <div class="step-buttons">
                <button
                    *ngIf="currentStep === 2"
                    pButton
                    pRipple
                    label="Indietro"
                    icon="pi pi-arrow-left"
                    class="p-button-outlined p-button-secondary"
                    [disabled]="salvataggioInCorso"
                    (click)="previousStep()">
                </button>
                <button
                    *ngIf="currentStep === 1"
                    pButton
                    pRipple
                    label="Avanti"
                    icon="pi pi-arrow-right"
                    class="p-button-success"
                    (click)="nextStep()"
                    [disabled]="!isStep1Valid() || salvataggioInCorso">
                </button>
                <button
                    *ngIf="currentStep === 2"
                    pButton
                    pRipple
                    [label]="salvataggioInCorso ? '' : 'Salva'"
                    [icon]="salvataggioInCorso ? '' : 'pi pi-check'"
                    class="p-button-success"
                    (click)="salvaRendicontazione()"
                    [disabled]="!isStep2Valid() || salvataggioInCorso">
                    <ng-container *ngIf="salvataggioInCorso">
                        <i class="pi pi-spin pi-spinner" style="margin-right: 0.5rem;"></i>
                        Salvataggio...
                    </ng-container>
                </button>
            </div>
        </div>
    </div>
</p-dialog>

<p-toast position="top-right"></p-toast>
